import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/home/Home'
import About from './pages/about-us/About'
import Contact from './pages/contact-us/Contact'
import Faq from './pages/faq/Faq'
import Services from './pages/our-services/Services'
import Search from './pages/search/Search'
import Business from '@/pages/business/Business'
import Product from '@/pages/business/tabs/product/Product'
import Service from '@/pages/business/tabs/service/Service'
import Comment from '@/pages/business/tabs/Comment'
import Gallery from '@/pages/business/tabs/Gallery'
import Info from '@/pages/business/tabs/Info'
import Colony from '@/pages/business/tabs/Colony'
import Point from '@/pages/business/tabs/Point'
import Facility from '@/pages/business/tabs/Facility'
import Posts from '@/pages/business/tabs/Posts'
// import NotFound from '@/pages/other/NotFound'

const linkActiveClass = 'active-menu';
Vue.use(Router);

export default new Router({
    linkActiveClass,
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/about-us',
            name: 'about-us',
            component: About
        },
        {
            path: '/contact-us',
            name: 'contact-us',
            component: Contact
        },
        {
            path: '/faq',
            name: 'faq',
            component: Faq
        },
        {
            path: '/our-services',
            name: 'our-services',
            component: Services
        },
        {
            path: '/search/:keyword?/',
            name: 'search',
            component: Search
        },
        {
            path: '/:username',
            name: 'Business',
            props: true,
            component: Business,
            children: [
                // {
                //     path: '/',
                //     component: About
                // },
                {
                    path: '/',
                    component: Product,
                },
                {
                    path: 'product',
                    component: Product,
                },
                {
                    path: 'about',
                    component: About
                },
                
                {
                    path: 'service',
                    component: Service
                },
                {
                    path: 'comment',
                    component: Comment
                },
                {
                    path: 'gallery',
                    component: Gallery
                },
                {
                    path: 'info',
                    component: Info
                },
                {
                    path: 'group',
                    component: Colony
                },
                {
                    path: 'point',
                    component: Point
                },
                {
                    path: 'facility',
                    component: Facility
                },
                {
                    path: 'posts',
                    component: Posts
                }
            ]
        },

    ]

})